import { configureStore } from '@reduxjs/toolkit'

import { chainlitApiSlice } from '@/features/aiAssistant/redux'
import { mddApiSliceGenerated } from '@/rtkApi'
import { mddApiSliceGeneratedV2 } from '@/rtkApi/mddApiSliceGeneratedV2'
import {
	diagramApiSlice,
	historyApiSlice,
	templateApiSlice,
} from '@/rtkQueries'

import { rootReducer } from './modules'

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: { warnAfter: 128 },
			serializableCheck: { warnAfter: 128 },
		})
			.concat(diagramApiSlice.middleware)
			.concat(historyApiSlice.middleware)
			.concat(templateApiSlice.middleware)
			.concat(chainlitApiSlice.middleware)
			.concat(mddApiSliceGenerated.middleware)
			.concat(mddApiSliceGeneratedV2.middleware),
	devTools: { trace: true, traceLimit: 30 },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export * from './modules'
